import { render, staticRenderFns } from "./total_transaksi_servis.vue?vue&type=template&id=0a22fda5&"
import script from "./total_transaksi_servis.vue?vue&type=script&lang=js&"
export * from "./total_transaksi_servis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports